<ui-card-page>
	<ng-container modal-header>
		<div style="margin-top: 40%;" class="resume_header">
			<img style="width: 112px; height: 112px;" [src]="'assets/images/ibk-outschedule.png' | locationAssets" alt="ibk"/>
		</div>
	</ng-container>
	<ng-container modal-body>
		<div class="resumen_body">
			<div class="resumen_body__cardholder">
				<div class="resume_header__title_outschedule">Fuera del horario de</div>
				<div class="resume_header__title_outschedule" style="margin-bottom: 16px;">atención</div>
				<div class="resumen_item__title_outschedule">Recuerda que nuestro horario de</div>
				<div class="resumen_item__title_outschedule"> atención es de <b>8 de la mañana a</b></div>
				<div class="resumen_item__title_outschedule"><b>10 de la noche</b></div>
			</div>
			<div class="resumen_body__form">
				<ibk-button>
					<a href="https://interbank.pe/"
					   style="display:inline-block;width: 248px;text-decoration: inherit;text-align: center"
					   class="ibk-btn ibk-btn--primary">
						Entendido
					</a>
				</ibk-button>
			</div>
		</div>
	</ng-container>
</ui-card-page>
